export { SearchResultCard as default } from './search-result-card';
export * from './search-result-card';
